import { render, staticRenderFns } from "./VaScrollbar.vue?vue&type=template&id=237142a9&"
import script from "./VaScrollbar.vue?vue&type=script&lang=js&"
export * from "./VaScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./VaScrollbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports